export default "__VITE_ASSET__BFEoh62___"